// extracted by mini-css-extract-plugin
export default {"wrapper":"loggedMenu_wrapper__l+5Yt","buttons":"loggedMenu_buttons__slW5A","infoButton":"loggedMenu_infoButton__2F+VO"};